import layoutsComponents from "../../web-sh/src/layouts/components";

import Header from "./Header";
import Footer from "./Footer";
import Other from "./Other";
import SidebarBottom from "./SidebarBottom";
import SidebarCenter from "./SidebarCenter";

layoutsComponents.Header = Header;
layoutsComponents.Footer = Footer;
layoutsComponents.Other = Other;
layoutsComponents.SidebarBottom = SidebarBottom;
layoutsComponents.SidebarCenter = SidebarCenter;

export default layoutsComponents;